module.exports = __webpack_public_path__ + "img/hero-shape-large.76fcf1a4.svg";